// extracted by mini-css-extract-plugin
export default {"textField":"StoryTableFilter-textField-fbd66ba97cebbd8188de7685bbdfeba3","adornment":"StoryTableFilter-adornment-67018438087934911d19c33e418f1c89"};